export default "__VITE_ASSET__DeKl6E8I__"